const constantsRiachuelo = {
	keyRiachueloNegotiationType: "RIACHUELO_NEGOTIATION_TYPE",
	valueStringOverduedOnly: "overdued_only",
	valueStringOverduedAndUpcoming: "overdued_and_upcoming",
};

export default constantsRiachuelo;
